import { toApiError } from './api-error';
import { BackendErrorCode } from './backend-error-code';

/**
 * Повтор того же запроса за 3 с — `15 IDEMPOTENCY` (`IdempotentRequest.php`, IMGM-1561).
 *
 * Это не отказ: первый запрос уже всё сделал и сам покажет успех. Поэтому такой отказ не
 * показывают ни тостом, ни текстом в окне — место вызова молча выходит. Фильтровать внутри
 * `describeApiError` нельзя: он обязан вернуть текст.
 */
export function isDuplicateRequest(error: unknown): boolean {
  return toApiError(error).code === BackendErrorCode.IDEMPOTENCY;
}
